import axios from 'axios';

const METRICS_API_URL = 'https://vo6eskps87.execute-api.us-east-1.amazonaws.com/prod/metrics';

export const getMetrics = async () => {
  try {
    const response = await axios.get(METRICS_API_URL, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    console.log("MetricsAPIHelper :: getMetrics :: response :: ", response);
    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
